import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { SelectEventSessionPage } from 'src/app/modals/select-event-session/select-event-session.page';

const routes: Routes = [
  {
    path: '',
    component: SelectEventSessionPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SelectEventSessionPage]
})
export class SelectEventSessionPageModule {}
